import type { FC, ReactNode } from 'react'

import { ChevronDown } from 'lucide-react'
import { Reveal } from '@/components/generals/reveal'

const QUESTIONS = [
    {
        question: 'צריך ניסיון קודם בתיאטרון?',
        answer: 'ממש לא. כל אחד מתחיל מהמקום שבו הוא נמצא, והקבוצות בנויות כך שגם מי שמגיע בפעם הראשונה ירגיש בבית.'
    },
    {
        question: 'הילד שלי ביישן. זה מתאים לו?',
        answer: 'בהחלט. ילדים ביישנים מגלים לא פעם שדווקא על הבמה הכי קל להם להעז. מתקדמים בהדרגה, בלי לחץ ובלי לדחוף אף אחד לעמוד מול כולם לפני שהוא מוכן.'
    },
    {
        question: 'איך יודעים לאיזו קבוצה להירשם?',
        answer: 'הקבוצות מחולקות לפי שכבות גיל. אם יש התלבטות, נדבר עליה כשנחזור אליכם ונמצא יחד את הקבוצה המתאימה.'
    },
    {
        question: 'מה לובשים לשיעור?',
        answer: 'בגדים נוחים שמאפשרים תנועה, ונעליים נוחות או גרביים. אין צורך בתלבושת מיוחדת.'
    },
    {
        question: 'מה קורה אחרי שיעור הניסיון?',
        answer: 'מדברים, שומעים איך היה ומחליטים יחד אם להצטרף לקבוצה. אין שום התחייבות.'
    }
]

const FaqSection: FC = (): ReactNode => {
    return (
        <section id='faq' aria-labelledby='faq-title' className='scroll-mt-16 py-20 sm:py-28'>
            <div className='mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:gap-16'>
                <Reveal>
                    <p className='text-sm font-medium text-primary'>
                        שאלות של הורים
                    </p>

                    <h2 id='faq-title' className='mt-3 font-heading text-4xl font-bold leading-tight text-balance sm:text-5xl'>
                        לפני שעולים לבמה
                    </h2>

                    <p className='mt-5 max-w-md text-base leading-relaxed text-muted-foreground text-pretty sm:text-lg'>
                        התשובות לשאלות שהורים שואלים הכי הרבה. יש לכם שאלה אחרת? כתבו אותה בטופס ונחזור אליכם.
                    </p>
                </Reveal>

                <Reveal delay={120} className='space-y-3'>
                    {QUESTIONS.map((item) => (
                        <details
                            key={item.question}
                            className='group rounded-2xl border border-border bg-card/50 px-6 transition-colors duration-300 open:border-primary/30 open:bg-card/80'
                        >
                            <summary className='flex min-h-16 cursor-pointer list-none items-center justify-between gap-4 py-4 font-heading text-lg font-bold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring sm:text-xl [&::-webkit-details-marker]:hidden'>
                                {item.question}
                                <ChevronDown aria-hidden='true' className='size-5 shrink-0 text-primary transition-transform duration-300 group-open:rotate-180' />
                            </summary>

                            <p className='pb-6 leading-relaxed text-muted-foreground text-pretty'>
                                {item.answer}
                            </p>
                        </details>
                    ))}
                </Reveal>
            </div>
        </section>
    )
}

export default FaqSection
